import React from "react";
import "./styles.scss";

// Import logos
import hdaLogo from "../../assets/img/logos/hda.png";
import cooperacaoAlemaLogo from "../../assets/img/logos/cooperacao-alema.png";
import chinaLogo from "../../assets/img/logos/china.png";
import aterDigitalLogo from "../../assets/img/logos/ater-digital.png";
import octLogo from "../../assets/img/logos/oct.png";
import manejeBemLogo from "../../assets/img/logos/manaje-bem.png";
import orangeLeafLogo from "../../assets/img/logos/orange-leaf.png";
import greenBottleLogo from "../../assets/img/logos/green-bottle.png";

const LogosBanner = () => {
  return (
    <div className="logos-banner">
      <div className="logos-container">
        <img src={hdaLogo} alt="HDA" className="logo" />
        <img src={cooperacaoAlemaLogo} alt="Cooperação Alemã" className="logo" />
        <img src={chinaLogo} alt="China" className="logo" />
        <img src={orangeLeafLogo} alt="Orange Leaf" className="logo" />
        <img src={greenBottleLogo} alt="Green Bottle" className="logo" />
        <img src={octLogo} alt="OCT" className="logo" />
        <img src={manejeBemLogo} alt="Maneje Bem" className="logo" />
      </div>
    </div>
  );
};

export default LogosBanner;
